<template>
  <div id="container">
    <div>
      <div
        class="config-instruction"
        style="padding:10px 20px;margin-bottom: 20px;border-radius: 4px;">
        <i
          class="el-icon-warning-outline"
          style="font-size: 16px;vertical-align: middle;padding-right: 5px;"></i>
        <span class="waring_title">提成比例根据公司规定进行设置，销售人员提成根据流水以及提成比例等进行计算，请慎重修改提成。</span>
      </div>
    </div>
    <div class="item-box-content">
      <div style="display: flex;align-items: center;justify-content: space-between">
        <div>
          <div class="title-font-style">
            <span>提成比例设置</span>
          </div>
        </div>
        <div>
          <el-button
            type="primary"
            plain
            @click="onAddOrEditUnit(1,1)">添加
          </el-button>
          <el-button
            plain
            type="danger"
            @click="onDelete">删除
          </el-button>
        </div>
      </div>
      <!-------------- 列表 -------------->
      <div style="margin-top: 20px;">
        <el-table
          border
          ref="tableRef"
          :data="newlist"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column
            prop="id"
            fixed="left"
            label="序号"
            type="index"
            width="100px"></el-table-column>
          <el-table-column
            prop="commission"
            label="提成比例">
            <template v-slot="{ row }">
              {{row.commission || 0}}
            </template>
          </el-table-column>
          <!-- </el-form-item> -->
          <el-table-column
            prop
            label="操作"
            label-width="0px"
            width="100px">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="onAddOrEditUnit(scope.row,2)">编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div
          class="commission-percentage"
          style="margin-top:20px">
          <span class="commission-percentage-title">提成比例规则代码:</span>
          <el-input
            type="textarea"
            v-model="saleir"
            rows="8"></el-input>
        </div>

        <el-button
          type="primary"
          @click="onsave"
          style="margin-top: 20px;">保存
        </el-button>
      </div>
      <!-------------- 新增/更改银行账号信息 -------------->
      <add-commission-Percentage ref="addEditBrandRefs"></add-commission-Percentage>
    </div>
  </div>
</template>

<script>
  import {
    delteCommissInfo,
    CommissionList,
    AddSalire
  } from '@/api/system/rightsManagement'
  import addcommissionPercentage from '../dialog/addcommissionPercentage'
  import NP from 'number-precision'

  var _this
  export default {
    components: {
      'add-commission-Percentage': addcommissionPercentage
    },
    computed: {
      newlist () {
        if (this.list.length > 0) {
          this.list.forEach((v, i) => {
            v['commission'] = `${NP.strip(v['commission'] * 100)}%`
            //
          })
          return this.list
        }
      }
    },
    data () {
      return {
        queryParams: {},
        params: {},
        editItem: {},
        contractScreenCondition: [],
        // expressionList: expressionList,
        loadingTable: false, // 列表loading
        list: [], // 列表数据
        pageSize: 30, // 页数
        currentPage: 1, // 页码
        total: 0, // 列表总数
        value1: false,
        value2: true,
        saleir: ''
      }
    },
    mounted () {
      _this = this
      _this.getInitTable()
    },
    methods: {
      onsave () {
        let tempIds = [],
          ids = ''
        this.list.forEach(e => {
          tempIds.push(e['id'])
        })
        ids = tempIds.join(',')

        if (this.saleir.length == 0) {
          this.$message({
            message: '请先填写sql',
            type: 'error'
          })

          return
        }
        AddSalire(ids, this.saleir).then(res => {
          let isflag = true
          if (res.data.code != 200) {
            isflag = false
          }
          this.$message({
            message: isflag ? '保存成功' : '保存失败',
            type: isflag ? 'success' : 'error'
          })
          this.getInitTable()
        })
      },
      getInitTable: async () => {
        let response = await CommissionList()
        _this.list = response.data.obj
        // _this.list = response.data.obj;
        _this.saleir = response.data.obj[response.data.obj.length - 1]['serial']
        // hashtablelist
        let addlist = []
        _this.list.forEach(res => {
          let commis = `${res['commission']}`.split('%')
          addlist.push(commis[0])
        })
        _this.$refs.addEditBrandRefs.hashtablelist = addlist
      },
      // 设置头部背景色
      tableHeader ({ rowIndex }) {
        return this.$tableHeader(rowIndex)
      },
      // 新增提成比例设置
      onAddOrEditUnit (type, from) {
        this.$refs.addEditBrandRefs.CommissionPercentage = true
        if (from == 2) {
          this.$refs.addEditBrandRefs.CommisValues = type
        }
        this.$refs.addEditBrandRefs.onInitialize(type, from)
      },
      // 删除
      onDelete () {
        let lastchild = _this.list[_this.list.length - 1]['id']
        delteCommissInfo(lastchild).then(res => {
          let isflag = true
          if (res.data.code !== 200) {
            isflag = false
          }
          this.$message({
            message: isflag ? '删除成功' : '删除失败',
            type: isflag ? 'success' : 'error'
          })
          this.getInitTable()
        })
      },
      // 页数
      handleSizeChange (val) {
        this.pageSize = val
        this.getList()
      },
      // 页码
      handleCurrentChange (val) {
        this.currentPage = val
        this.getList()
      }
    }
  }
</script>

<style
  lang="scss"
  scoped>
  .commission-percentage {
    display: flex;
    font-size: 12px;
  }

  .commission-percentage-title {
    width: 120px;
  }

  .waring_title {
    font-size: 14px;
    color: #d35e5e;
  }

  ::v-deep .el-icon-warning-outline {
    padding-right: 10px;
  }
</style>
